
const rawMaterialCompleteStatuses = [
    {
        "id":'1',
        "no":"R21081201",
        "rawMaterials":[
            {
                "id":"1",
                "decision":"",
                "comments":""
            },
            {
                "id":"2",
                "decision":"",
                "comments":""
            },
            {
                "id":"3",
                "decision":"",
                "comments":""
            },
            {
                "id":"4",
                "decision":"",
                "comments":""
            },
            {
                "id":"5",
                "decision":"",
                "comments":""
            },
            {
                "id":"6",
                "decision":"",
                "comments":""
            },
            {
                "id":"7",
                "decision":"",
                "comments":""
            },
            {
                "id":"8",
                "decision":"",
                "comments":""
            },
            {
                "id":"9",
                "decision":"",
                "comments":""
            },
            {
                "id":"10",
                "decision":"",
                "comments":""
            },
            {
                "id":"11",
                "decision":"",
                "comments":""
            },
            {
                "id":"12",
                "decision":"",
                "comments":""
            }
        ]


    },
    {
        "id":'2',
        "no":"A21080203",
        "assessmentProducts":[
            {
                "id":"1",
                "rawMaterials":[
                    {
                        "id":"1",
                        "decision":"",
                        "comments":""
                    },
                    {
                        "id":"2",
                        "decision":"",
                        "comments":""
                    },
                    {
                        "id":"3",
                        "decision":"",
                        "comments":""
                    },
                    {
                        "id":"4",
                        "decision":"",
                        "comments":""
                    },
                    {
                        "id":"5",
                        "decision":"",
                        "comments":""
                    },
                    {
                        "id":"6",
                        "decision":"",
                        "comments":""
                    },
                    {
                        "id":"7",
                        "decision":"",
                        "comments":""
                    },
                    {
                        "id":"8",
                        "decision":"",
                        "comments":""
                    },
                    {
                        "id":"9",
                        "decision":"",
                        "comments":""
                    },
                    {
                        "id":"10",
                        "decision":"",
                        "comments":""
                    },
                    {
                        "id":"11",
                        "decision":"",
                        "comments":""
                    },
                    {
                        "id":"12",
                        "decision":"",
                        "comments":""
                    }
                ]
            }
        ]
    },
    {
        "id": "3",
        "no": "change",
        "rawMaterials":[
            {
                "id":"1",
                "decision":"",
                "comments":""
            },
            {
                "id":"2",
                "decision":"",
                "comments":""
            },
            {
                "id":"3",
                "decision":"",
                "comments":""
            }
        ]
    }
]

export default rawMaterialCompleteStatuses;